import { render } from "./DynvibeColumnStacked.vue?vue&type=template&id=b12d4926"
import script from "./DynvibeColumnStacked.vue?vue&type=script&lang=js"
export * from "./DynvibeColumnStacked.vue?vue&type=script&lang=js"

import "./DynvibeColumnStacked.vue?vue&type=style&index=0&id=b12d4926&lang=css"

import exportComponent from "/Users/hamzaassif/Work/detect-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__